import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    flex-shrink: 0;\n    ", ";\n    ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n                ", ";\n                background-color: transparent;\n            "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n        "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    flex-shrink: 0;\n    ", ";\n    &:hover {\n        color: ", ";\n        background-color: ", ";\n    }\n    border-radius: ", ";\n    user-select: none;\n    ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            visibility: hidden;\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n                ", ";\n                color: ", ";\n                background-color: ", ";\n\n                &:hover {\n                    background-color: ", ";\n                }\n            "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n                ", ";\n                background-color: ", ";\n                border-radius: 0;\n            "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n                ", ";\n                border-bottom-left-radius: 0;\n                border-top-left-radius: 0;\n            "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n                ", ";\n                border-bottom-right-radius: 0;\n                border-top-right-radius: 0;\n            "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    grid-template-rows: auto;\n    row-gap: ", ";\n    place-content: center;\n    margin: 0 ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    ", ";\n    font-weight: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 ", ";\n    user-select: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    grid-template-rows: auto;\n    row-gap: ", ";\n    place-content: center;\n    margin: 0 ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    padding: ", ";\n    //min-height: ", ";\n\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { getPropsBlocker } from '../../../utils';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { borderRadius, color, reset, spacing, typography } from '../../../system';
import { transition } from '../../../system/mixins/transition';
import { fontWeightMedium } from '../../../tokens';
var propertyList = {
  current: true,
  selected: true,
  leftEnd: true,
  rightEnd: true,
  left: true,
  right: true,
  weekDay: true,
  displayedMonth: true,
  month: true,
  year: true,
  day: true,
  applyValue: true,
  onDisplayedDateUTCUpdate: true,
  onDirtyInternalValueUTCUpdate: true
};
export var DatePickerDaySelectorRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject(), reset, typography('paragraphMedium'), spacing(4), spacing(84), getComponentOverride('DatePickerDaySelector'));
export var DatePickerDaySelectorWeek = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject2(), spacing(1), spacing(-0.5));
export var DatePickerDaySelectorWeekDay = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject3(), spacing(10), spacing(10), color('neutral.06'), typography('paragraphSmall'), fontWeightMedium, spacing(0.5));
export var DatePickerDaySelectorDays = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject4(), spacing(1), spacing(-0.5));
export var DatePickerDaySelectorDay = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject5());

var getDayButtonStyle = function getDayButtonStyle(_ref) {
  var selected = _ref.selected,
      leftEnd = _ref.leftEnd,
      rightEnd = _ref.rightEnd,
      displayedMonth = _ref.displayedMonth;
  var result = {};

  if (displayedMonth && selected) {
    if (leftEnd && !rightEnd) {
      result = css(_templateObject6(), result);
    }

    if (rightEnd && !leftEnd) {
      result = css(_templateObject7(), result);
    }

    if (!rightEnd && !leftEnd) {
      result = css(_templateObject8(), result, color('primary.lightest'));
    }

    if (rightEnd || leftEnd) {
      result = css(_templateObject9(), result, color('neutral.00'), color('primary.main'), color('primary.light'));
    }
  }

  if (!displayedMonth) {
    result = css(_templateObject10(), result);
  }

  return result;
};

export var DatePickerDaySelectorDayButton = styled.a.withConfig(getPropsBlocker(propertyList))(_templateObject11(), spacing(10), spacing(10), color('neutral.06'), typography('paragraphSmall'), transition({
  'background-color': 0.1,
  color: 0.1
}), color('neutral.00'), color('primary.main'), borderRadius('soft'), getDayButtonStyle);

var getDayPaddingStyle = function getDayPaddingStyle(_ref2) {
  var selected = _ref2.selected,
      leftEnd = _ref2.leftEnd,
      rightEnd = _ref2.rightEnd,
      left = _ref2.left,
      right = _ref2.right,
      displayedMonth = _ref2.displayedMonth;
  var result = {};

  if (displayedMonth && selected) {
    result = css(_templateObject12(), result, color('primary.lightest'));

    if (right && rightEnd || left && leftEnd) {
      result = css(_templateObject13(), result);
    }
  }

  return result;
};

export var DatePickerDaySelectorDayPadding = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject14(), spacing(0.5), spacing(10), transition({
  'background-color': 0.1,
  color: 0.1
}), getDayPaddingStyle);